import { rem } from 'polished';
import styled from 'styled-components';

export default styled.button`
  appearance: none;
  background-color: ${props => props.theme.colors.red};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: ${rem(28)};
  left: 24px;
  padding: 0;
  position: absolute;
  top: 16px;
  width: ${rem(28)};

  svg {
    align-self: center;
    margin: 0 auto;
  }
`;
